import KendoDateAndOrTimePickerViewModelBase from '@/Components/KendoDateTimePicker/ViewModels/KendoDateAndOrTimePickerViewModelBase';
import * as DateHelper from '@/Utility/DateHelper'

export default class KendoDatePickerViewModelBase extends KendoDateAndOrTimePickerViewModelBase {

    /**
     * Das minimal ausw�hlbare Datum im DatePicker
     */
    public min: KnockoutObservable<Date>;

    /**
     * Das maximal ausw�hlbare Datum im DatePicker
     */
    public max: KnockoutObservable<Date>;

    /**
     * Das Date-Objekt als String im Format der aktuellen Sprache
     */
    public dateString: KnockoutComputed<string>;

    public constructor(params: any) {
        super(params);
        this.min = this.observableOrDefault(params.min, new Date(1900, 0, 1));;
        this.max = this.observableOrDefault(params.max, new Date(2099, 11, 31));
        this.dateString = this.defineComputed(() => {
            const date = this.date();
            const value = DateHelper.toString(date);
            return value;
        });
    }

    public customValidate(value: string, isNullableType: boolean): boolean {
        const date = this.date();

        if (isNullableType)
            return String.isNullOrEmpty(value) || date != null;

        return date != null;
    }

    public canReset(): boolean {
        return !String.isNullOrEmpty(this.rawValue());
    }
}
